module.exports = __webpack_public_path__ + "static/media/check_rectangle.39341164.svg";